import { render, staticRenderFns } from "./ModalDetailsBancoCaixa.vue?vue&type=template&id=0df38591&scoped=true&"
import script from "./ModalDetailsBancoCaixa.vue?vue&type=script&lang=ts&"
export * from "./ModalDetailsBancoCaixa.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDetailsBancoCaixa.vue?vue&type=style&index=0&id=0df38591&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df38591",
  null
  
)

export default component.exports